import { render, staticRenderFns } from "./RecordingChallengeList.vue?vue&type=template&id=67250b06&scoped=true&"
import script from "./RecordingChallengeList.vue?vue&type=script&lang=js&"
export * from "./RecordingChallengeList.vue?vue&type=script&lang=js&"
import style0 from "./RecordingChallengeList.vue?vue&type=style&index=0&id=67250b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67250b06",
  null
  
)

export default component.exports